import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {handleEvent} from '../../../../events/event-handler';

const getDataFromNode = function(node) {
    return ['id', 'x', 'y', 'src', 'visible', 'enabled', 'click_state', 'zIndex', 'title', 'alpha',
        'sprite_initial_index'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

class ButtonNode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            hovered: false
        };

        // change enabled from a string to a boolean
        this.state.enabled = (this.state.enabled === '1');
        this.state.visible = (this.state.visible === '1');

        this.enableButton = this.enableButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.showButton = this.showButton.bind(this);
        this.hideButton = this.hideButton.bind(this);
    }

    componentDidMount() {
        document.addEventListener('jre-btn-enabled', this.enableButton);
        document.addEventListener('jre-btn-disabled', this.disableButton);

        document.addEventListener('jre-btn-show', this.showButton);
        document.addEventListener('jre-btn-hide', this.hideButton);
    }

    componentWillUnmount() {
        document.removeEventListener('jre-btn-enabled', this.enableButton);
        document.removeEventListener('jre-btn-disabled', this.disableButton);

        document.removeEventListener('jre-btn-show', this.showButton);
        document.removeEventListener('jre-btn-hide', this.hideButton);

    }

    enableButton(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({enabled: true});
        }
    }

    disableButton(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({enabled: false});
        }
    }

    showButton(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({visible: true});
        }
    }

    hideButton(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({visible: false});
        }
    }

    onImgLoad({target:img}) {
        // The image is an sprite image (a single image containing 5 elements).
        this.setState({height: parseInt(img.naturalHeight) / 5});
    }

    styleBackgroundPosition() {
        const {height = 0, hovered = false, sprite_initial_index} = this.state;

        if (hovered) {
            return `0 -${parseInt(height)}px`;
        } else if(sprite_initial_index !== undefined) {
            const offset = parseInt(height) * sprite_initial_index;
            return `0 -${offset}px`;
        } else {
            return '0 0';
        }
    }

    onButtonMouseOver() {
        this.setState({ hovered:true });
    }

    onButtonMouseOut() {
        this.setState({ hovered:false });
    }

    interactionComplete() {
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'onclick') {
                handleEvent(event);
            }
        });
    }

    render() {
        const {moduleURL = '', disabled} = this.props;
        const {x = 0, y = 0, src = '', click_state = 'normal', enabled = false, zIndex = null, title='', alpha=''} = this.state;
        let {visible = false, height = 0} = this.state;

        let background = `url(${moduleURL}/media/${src}) no-repeat`;
        if(src === '') {
            height = '100';
            visible = true;
            background = 'transparent';
        }
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            display: visible ? 'block' : 'none',
            height: `${height}px`,
            background: background,
            backgroundPosition: this.styleBackgroundPosition(),
            opacity: alpha,
        };

        if (zIndex !== null) {
            divStyle['zIndex'] = zIndex;
        }
        const buttonAttrs = {
            'data-enabled': enabled,
            'data-click-state': click_state
        };

        // if a disabled prop is passed from te_node parent, use that prop to determine button disable
        // if the prop is not passed for disabled (button node is independent of any parents), use enabled state from XML file.
        let isButtonDisabled = (disabled ? disabled : !enabled);

        return (
            <button className="node button-node" style={divStyle} onMouseOut={this.onButtonMouseOut.bind(this)}
                    onMouseOver={this.onButtonMouseOver.bind(this)} onClick={this.props.onClick || this.interactionComplete.bind(this)}
                    disabled={isButtonDisabled}>
                {/* This non-visible image element is used to get the height of the image. */}
                {
                    (src !== '') &&
                    <img onClick={this.props.onClick || this.interactionComplete.bind(this)} className="visibility-hidden"
                         onLoad={this.onImgLoad.bind(this)}
                         {...buttonAttrs} src={`${moduleURL}/media/${src}`}/>
                }
                {
                    // Enrichments 'Done' buttons are sometimes missing a source attribute in the xml, and not
                    // rendering. We use below code block to render a done button
                    (src === '') &&
                    <div onClick={this.props.onClick || this.interactionComplete.bind(this)} className="fake-button"
                         onLoad={this.onImgLoad.bind(this)}
                         {...buttonAttrs} src={`${moduleURL}/media/${src}`}>
                        { title }
                    </div>
                }
            </button>
        );
    }
}

ButtonNode.propTypes = {
    node: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    height: PropTypes.number
};

export default withRouter(ButtonNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/button-node.js